import { type TeamMemberType } from "@fwa/src/types";

import { Avatar, Text } from "@cruk/cruk-react-components";
import { imagePathFromImageType } from "@fwa/src/services/imageService";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";

import styles from "@fwa/src/components/TeamMembersOverviewPodium/styles.module.css";

type MedalArrayType = "gold" | "silver" | "bronze";

const PodiumMember = ({
  member,
  medalColor,
}: {
  member: TeamMemberType;
  medalColor: MedalArrayType;
}) => {
  const [brandName] = useBrandContext();
  if (!member) return null;

  const name = member.childPage.owner?.displayName
    ? member.childPage.owner?.displayName
    : member.childPage.fundraiser.forename;
  // if image avatar image url is undefined use a default letter.
  const fundraiserProfileImageUrl = member.childPage.fundraiser.profileImage
    ? imagePathFromImageType(member.childPage.fundraiser.profileImage)
    : undefined;
  // user with a displayname should not use profile image here.
  const imageUrl = member.childPage.owner?.displayName
    ? undefined
    : fundraiserProfileImageUrl;

  return (
    <div
      className={styles["position-wrapper"]}
      key={member.uniqueId}
      data-is-first={medalColor === "gold" ? "true" : "false"}
    >
      <div
        className={styles["user-icon-wrapper"]}
        key={member.uniqueId}
        data-medal-color={medalColor}
      >
        <Avatar
          name={name}
          url={imageUrl}
          alt={`${member.childPage.fundraiser.forename} is currently winning the ${medalColor} medal`}
          themeName={brandName}
          size="full"
        />
      </div>
      {medalColor === "gold" && (
        <div className={styles["first-place-wrapper"]}>
          <Text textColor="text-dark">1st</Text>
        </div>
      )}
    </div>
  );
};

export const TeamMembersOverviewPodium = ({
  members,
}: {
  members: TeamMemberType[];
}) => {
  const firstPlace = members?.[0];
  const secondPlace = members?.[1];
  const thirdPlace = members?.[2];

  return (
    <div className={styles["podium-wrapper"]}>
      {firstPlace ? (
        <PodiumMember member={firstPlace} medalColor="gold" />
      ) : null}
      {secondPlace ? (
        <PodiumMember member={secondPlace} medalColor="silver" />
      ) : null}
      {thirdPlace ? (
        <PodiumMember member={thirdPlace} medalColor="bronze" />
      ) : null}
    </div>
  );
};

export default TeamMembersOverviewPodium;
